import { T } from 'gt-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Currency } from '@/components/common/Currency';
import type { ArInvoiceLineItem } from '@erp/rpc';

interface ARInvoiceLineItemsProps {
  lineItems: ArInvoiceLineItem[];
  currency?: string | null;
}

export function ARInvoiceLineItems({
  lineItems,
  currency,
}: ARInvoiceLineItemsProps) {
  const currencyCode = currency ?? 'USD';

  if (lineItems.length === 0) {
    return (
      <p className="text-sm text-muted-foreground py-4 text-center">
        <T>No line items</T>
      </p>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>
            <T context="table column header for product name">Product</T>
          </TableHead>
          <TableHead className="text-right">
            <T context="table column header for quantity">Qty</T>
          </TableHead>
          <TableHead className="text-right">
            <T context="table column header for unit price">Unit Price</T>
          </TableHead>
          <TableHead className="text-right">
            <T context="table column header for line total">Line Total</T>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {lineItems.map((item) => (
          <TableRow key={item.id}>
            <TableCell>
              <div className="text-sm">
                {item.productName ?? item.productSku ?? '—'}
              </div>
              {item.productName && item.productSku && (
                <div className="text-xs text-muted-foreground">
                  {item.productSku}
                </div>
              )}
            </TableCell>
            <TableCell className="text-right text-sm">
              {item.quantity ?? '—'}
            </TableCell>
            <TableCell className="text-right text-sm">
              <Currency
                value={item.unitPrice}
                currency={currencyCode}
                fallback="—"
              />
            </TableCell>
            <TableCell className="text-right text-sm font-bold">
              <Currency value={item.lineTotal} currency={currencyCode} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
